<template>
  <header class="header" :class="{ 'header--home': $route.path === '/' }">
    <div class="otherentry">
      <ul>
        <li><a :href="url + '/salesSystem/#/login'" target="_blank"><img src="./img/jyyicon1.png" alt="" />分销系统</a></li>
        <li><a :href="url + '/djxwork/#/'" target="_blank"><img src="./img/fxxticon1.png" alt="" />救援云平台</a></li>
        <!-- <router-link tag="li" to="http://www.test.dajiuxing.com.cn/salesSystem/#/login"><img src="./img/fxxticon.png" alt="" />分销系统</router-link>
        <router-link tag="li" to="http://api.test.dajiuxing.com.cn"><img src="./img/jyyicon.png" alt="" />救援云平台</router-link> -->
      </ul>
    </div>
    <div class="bg">
      <div class="logoapp">
        <div class="logo">
          <h6>
            <img class="logoimg" src="./img/logo.png" alt="" />
          </h6>
          <h6 style="padding-top: 0.5vw;">
            <img style="height: 2vw;" src="./img/yqbj.png" alt="" />
          </h6>
          <div class="nav_right">
            <!-- <p class="mobile">手机端应用</p>
            <p class="miniapp">公众号应用</p> -->
            <!-- <p><a href="http://shopping.dajiuxing.com.cn/publish.php?catid=&cityid=" target="_blank">发 布</a></p> -->
            <!-- <h5><a href="http://shopping.dajiuxing.com.cn/member.php?cityid=0" target="_blank">登录</a><a href="http://shopping.dajiuxing.com.cn/member.php?mod=register&action=person&cityid=0" target="_blank">/注册</a></h5> -->
          </div>
          <div class="navbar">
        <ul style="font-size:16px;margin-top: 24px;">
          <li :class="{'only': only==item.id,'header-shop':index==1}" v-for="(item,index) in list" :key="index" @click="head(index,item)">
            <span>{{item.name}}</span>
            <div v-if="item.child">
              <b class="top"><i class="top-arrow1"></i><i class="top-arrow2"></i></b>
              <p style="font-size:16px" v-for="(list,index) in item.child" :key="index" @click="heads(index,list)"><a>{{list.name}}</a></p>
            </div>
          </li>
          <!-- <li><a href="http://shopping.dajiuxing.com.cn/" target="_blank">救援产品信息</a></li> -->
        </ul>
      </div>
        </div>
      </div>
      
    </div>

  </header>
</template>
<script>
import util from '@/util/util.js'
export default{
  data(){
    return {
      list:[
        {
          id:1,
          name:'首页',
          path:'/',
          namePath: 'index'
        },
        // {
        //   id:6,
        //   name:'品牌概览',
        //   path:'/about-the-savior',
        //   namePath: 'aboutTheSavior'
        // },
        // {
        //   id:2,
        //   name:'救援清单',
        //   path:'/rescuelist',
        //   child:[
        //   //   {
        //   //   id:1,
        //   //   name:'旅行救援服务',
        //   //   namePath: 'rescuelist'
        //   // },
        //   {
        //     id:1,
        //     name:'留学救援服务',
        //     namePath: 'rescuelist'
        //   },{
        //     id:2,
        //     name:'商旅救援服务',
        //     namePath: 'rescuelist'
        //   },{
        //     id:3,
        //     name:'劳务外派救援服务',
        //     namePath: 'rescuelist'
        //   },
        //   // {
        //   //   id:4,
        //   //   name:'一日游清单',
        //   //   namePath: 'rescuelist'
        //   // }
        //   ]
        // },
        {
          id:3,
          name:'服务能力',
          path:'/ability',
          namePath:'ability'
        },
        // {
        //   id:4,
        //   name:'客户问答',
        //   path:'/relation',
        //   namePath: 'relation'
        // },
        {
          id:5,
          name:'关于大救星',
          path:'/aboutus',
          namePath: 'aboutus'
        }
      ],
      url:util.config.url,
      urlApi: util.config.urlApi,
      only: 1
    }
  },
  beforeDestroy () {
    // 组件销毁之前,解除所有绑定
    this.$root.bus.$off('only')
  },
  created(){
    let that = this
    this.$root.bus.$on('only', value => {
      that.only = value
    })
    this.init()
  },
  methods:{
    
    init () {
      let that = this
      if (that.$route.path == '/rescuedetail') {
        this.only = 2
      } else {
        this.list.forEach((item) =>{
          if (item.path == that.$route.path) {
            that.only = item.id
          }
        })
      }

    },
    head (index,item) {
      console.log(item)
      console.log(index)
      if(this.$route.path == '/') {
        
      }
      // if (index !==1) {
        this.only = item.id;
        this.$router.push({
          path: item.path
        })
      // }
    },
    heads (index,item) {
      console.log(item)
      if (this.$route.path !== '/rescuelist') {
        this.only = 2
        this.$router.push({
          name: 'rescuelist',
          params:{
            id:item.id
          }
        })
      } else {
        this.$root.bus.$emit('pid', item.id)
        this.$root.bus.$emit('id', 1)
      }
    },
  }
}
</script>
<style lang="scss" scoped>
  .header{
    width: 100%;
    background: #f6f6f6;

    .otherentry{
      width: 63.0208333vw;
      margin: 0 auto;
      ul{
        overflow: hidden;
        li{
          float: right;
          margin-left: 2vw;
          line-height: 1.5625vw;
          color: #333;
          padding: 0 .8vw;
          font-size: .72917vw;
          cursor: pointer;
          a {
            color: #333;
          }
          img{
            margin-right: 0.5208333vw;
            width: 0.72917vw;
            height: 0.72917vw;
            vertical-align: middle;
          }
        }
      }
    }
    .bg {
    //  background: url(img/top-bg.png) no-repeat center center;
     background-size: 100% 100%;
     z-index: 11;
     
    }
    .logoapp{
      width: 100%;
      background: #fff;
      margin: 0 auto;
      padding-top:20px ;
      .logo{
        width: 63.0208333vw;
        margin: 0 auto;
        // padding: 5px 0;
        display: flex;
        justify-content: space-between;
        h6{
          color: #fff;
          font-size:1.354166vw;
          font-weight: normal;
          font-family:Songti SC;
          .logoimg{
            width: 7.29vw;
            height: 3.07292vw;
            margin-right: 1.354166vw;

          }
        }
        .nav_right{
          display: flex;
          align-items: center;
          h5{
            margin-left: 2.604166vw;
            font-size: .72917vw;
            color: #333;
          }
          p{
            padding: 0 .8vw;
            border:1px solid #fff;
            border-radius:0.833333vw;
            color: #fff;
            line-height: 1.6vw;
            text-align: center;
            margin-left: 2.604166vw;
            position: relative;
            cursor: pointer;
            font-size: .72917vw;
            &:hover{
              background: #81a5ec;
              color: #fff;
            }
            a{
              color: #00ABFA;
              &:hover{
                background: #00ABFA;
                color: #fff;
              }
            }
          }
          .miniapp:hover{
            &:after{
              content: '';
              position: absolute;
              display: block;
              height:6.25vw;
              width: 6.25vw;
              background: url(img/wxgzh_head.jpg) no-repeat;
              background-size: 100%;
              bottom: -6.5vw;
              z-index: 99;
              left: 50%;
              margin-left: -3.125vw;
            }
          }
          .mobile:hover{
            &:after{
                content: '';
                position: absolute;
                display: block;
                height:6.25vw;
                width: 6.25vw;
                background: url(img/app_head.jpg) no-repeat;
                background-size: 100%;
                bottom: -6.5vw;
                z-index: 99;
                left: 50%;
                margin-left: -3.125vw;
              }
            }
        }

      }
      .logo *{
        display: inline-block;
        vertical-align: middle;
      }
    }
    .navbar{
      width: 100%;
      margin: 0 auto;
      // background: #00ABFA;
      ul{
        width: 30vw;
        margin: 0 auto;
        margin-left: 30vw;
        li{
          line-height: 2.604166vw;
          display: inline-block;
          min-width: 8.5vw;
          /*padding: 0 1vw;*/
          text-align: center;
          color: #000;
          // font-size: 0.7vw;
          span{
            // color: #fff;
            /*padding: 4px;*/
          }
          a{
            color: #fff;
          }
        }
        .header-shop{
          position: relative;
        }
        .header-shop:hover em{
          display: block;
        }
        .header-shop:hover div{
          display: block;
        }
        .header-shop div{
          position: absolute;
          left: 0;
          top: 2.5vw;
          min-width:8.5vw;
          /*margin: 3px 0 0 0;*/
          background: #6681BB;
          -webkit-border-radius: 1px;
          -moz-border-radius: 1px;
          border-radius: 1px;
          z-index: 10;
          display: none;
          p {
            border-bottom: 1px solid rgba(255,255,255,0.5);
            a{
              display: inline-block;
              margin: 0 5px;
              /*min-width: 8vw;*/
              height: 100%;
              color: #fff;
              // border-bottom: 1px solid rgba(255,255,255,0.8);

            }
          }
          p:hover{
            background: #007cba;
          }
        }
        li:hover,.only{
          cursor: pointer;
          // background: #018FD9;
          // font-weight: bold;
          span{
            // border-bottom: 1px solid #fff;
            font-weight: bold;
            border-bottom: 2px solid #000;
          }
        }
      }
    }
  }
  /* 首页页头沿用平台系统的两侧留白，导航靠右排列以适应内容区宽度。 */
  .header.header--home {
    .otherentry,
    .logoapp .logo {
      width: calc(100% - 30vw);
    }
    .navbar {
      flex: 1;
      width: auto;
      ul {
        display: flex;
        justify-content: flex-end;
        width: auto;
        margin-left: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/indexHeader.vue